import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/logo-230-white.svg")